// import { Observable } from "rxjs";
// import { Injectable } from "@angular/core";
// import { HttpClient } from "@angular/common/http";
// import { andAllWhere, andWhere, buildQuery, CombinedFilter, FilterFn, noop, Normalizers, Ops, orderBy, OrderVariant, orWhere, page, where } from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
// import { DocumentClassAttributes, MastersUserAttributes, OrderAttributes, TripAttributes } from "@albatrosdeveloper/ave-models-package";
// import { AbstractService } from "app/services/abstract.service";
// import { IPagination, IPaginationDate, IPaginationResult, IPaginationResultFrequencies, IRequestResult } from "app/common/interfaces";
// import { environment as env } from "../../../../../environments/environment.prod";

// const apiUrl = env.API_AVE_TRIP_URL;
// const moduleName = 'trip';

// @Injectable({
//   providedIn: "root",
// })
// export class AgendaViewService extends AbstractService<
//   TripAttributes,
//   Partial<TripAttributes>,
//   Partial<TripAttributes>
// > {

//   currentFilter: CombinedFilter<TripAttributes>;
//   currentFilterData: any;

//   constructor(
//     http: HttpClient,
//   ) {
//     super(apiUrl, moduleName, http);
//   }

//     /**
//      * Pagination
//      * @param options Pagination options
//      * @returns Paginated data
//      */
//     findAllWithCountByTrip(
//       options: IPaginationDate<TripAttributes>,
//       date,
//     //   routeIds: number[]  // Add your companyIds if necessary
//     ): Observable<IPaginationResult<TripAttributes>> {
//       const query = buildQuery<TripAttributes>(
//       where("subRoute.name" as keyof TripAttributes, Ops.like(options.search ?? "", "i")),
//       orWhere("user.user_login.username" as keyof TripAttributes, Ops.like(options.search ?? "", "i")),
//       andAllWhere("dateHourStart", Ops.btwnDates(date.start, date.end)),
//         // routeIds && routeIds.length > 0 ? andAllWhere('subRoute.id' as keyof TripAttributes, Ops.in(...routeIds)) : noop(),
//       orderBy(
//           options.sort ?? "dateHourStart" as keyof TripAttributes,
//           options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
//         ),
//         page(options.currentPage ?? 1, options.limitPerPage ?? 100)
//     );

//       this.currentFilter = query;
//       //this.currentFilterData = dataToFilter;

//       const API_URL: string =
//         apiUrl +
//         `api/${moduleName}/withCountByTrip?filter=${encodeURIComponent(JSON.stringify(query))}`;
//       return this.http.get<IPaginationResult<TripAttributes>>(API_URL);
//     }

// }
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  // Utilizamos un BehaviorSubject para gestionar la fecha seleccionada.
  private selectedDateSource = new BehaviorSubject<Date>(new Date()); 
  selectedDate$ = this.selectedDateSource.asObservable();

  constructor() {}

  // Método para actualizar la fecha seleccionada
  setSelectedDate(date: Date): void {
    this.selectedDateSource.next(date);
  }

  // Método para obtener la fecha seleccionada
  getSelectedDate(): Date {
    return this.selectedDateSource.getValue();
  }
}
